module.exports = __webpack_public_path__ + "img/checkSmallDisabled.6351ec0b.svg";